'use client'

import Head from 'next/head'
import { useUser /*, withPageAuthRequired */ } from '@auth0/nextjs-auth0'
import DataWrapper from '@/components/common/DataWrapper'

const Profile = () => {
  const { user, error, isLoading } = useUser()

  return (
    <>
      <Head>
        <title>Profile (client)</title>
        <meta name="description" content="Profile client" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <div>
        <h1 className="text-2xl font-bold">Profile (client)</h1>
      </div>
      {isLoading && <p>Loading profile...</p>}
      {error && (
        <>
          <h2>Error</h2>
          <pre>{error.message}</pre>
        </>
      )}
      {user && (
        <div id="profile-client">
          <DataWrapper text={JSON.stringify(user, null, 2)} isCode={true} />
        </div>
      )}
    </>
  )
}

export default Profile
